var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.heights)?_c('div',{staticClass:"contents",style:({ height: _vm.heights + 'px' })}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }